import template from './tc-phone-number.html';
import controller from './tc-phone-number.controller';

let TcPhoneNumberComponent = {
  restrict: 'E',
  bindings: {
    ngModel: '=', // Two-way binding for the phone number value
    placeholder: '@?', // Optional placeholder text
    disabled: '<?', // Optional disabled state
    required: '<?', // Optional required state
    class: '@?', // Optional CSS classes
  },
  template,
  controller
};

export default TcPhoneNumberComponent;




// WEBPACK FOOTER //
// ./client/common/directives/phone-number/tc-phone-number.component.js